export enum PromoPaymentMethodEnum {
  CASH = "cash",
  TRANSFER = "transfer",
  INVOICE = "invoice",
}

export default PromoPaymentMethodEnum;
